var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{directives:[{name:"bar",rawName:"v-bar",value:({
    useScrollbarPseudo: true,
    overrideFloatingScrollbar: true,
  }),expression:"{\n    useScrollbarPseudo: true,\n    overrideFloatingScrollbar: true,\n  }"}],staticClass:"app-main"},[_c('section',{staticClass:"work-area--report",attrs:{"id":"top"}},[_c('div',{staticClass:"graphic-wrap"},[_c('dynamic-chart',{attrs:{"id":"printing"},on:{"onGetPeriod":_vm.getPeriod}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }